module.exports = __webpack_public_path__ + "static/media/part2.e74a98fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/wbstdt/imgs/partners/part2.png
// module id = 103
// module chunks = 0